/**
 * Vesti / Articles — svaki unos mora imati fotografiju 16:9.
 *
 * Note: Migrirano sa Strapi Blocks (TASK 20b) na Markdown content (TASK 23b).
 * `content` je sada Markdown string, renderuje se kroz `react-markdown` + `remark-gfm`.
 * Stari `news-items` Strapi tip više se ne koristi sa frontend-a — primarni izvor je `articles`.
 */
export interface NewsItem {
  id: string;
  documentId?: string;
  title: string;
  /** Backward-compat polje (excerpt iz Article-a; fallback na opis u news-items legacy) */
  description: string;
  /** Excerpt iz Strapi Article-a (ako postoji odvojeno od description) */
  excerpt?: string;
  /** Markdown body — full content za detail view */
  content?: string;
  /** URL-friendly slug (Strapi UID) */
  slug?: string;
  /** ISO datum (Strapi publishedAt) */
  publishedAt?: string;
  /** Featured flag — istakni karticu */
  featured?: boolean;
  /** Obavezno – URL slike u formatu 16:9 */
  image: string;
}

/** Naš program – svaki unos mora imati fotografiju 16:9 */
export interface ProgramItem {
  id: string;
  documentId?: string;
  title: string;
  subtitle: string;
  description: string;
  content?: string;
  slug?: string;
  publishedAt?: string;
  /** Obavezno – URL slike u formatu 16:9 */
  image: string;
}

/**
 * TASK 26: hardcoded mock vesti su uklonjene. Sve vesti sad dolaze iz Strapi
 * `articles` kolekcije (preko `fetchArticles`). Ako Strapi ne vrati ništa,
 * NewsScreen pokazuje "empty state" poruku (`t('news.empty')`).
 *
 * Export se zadržava kao prazan array radi backward-compat sa importima.
 */
export const NEWS_ITEMS: NewsItem[] = [];

/**
 * TASK 27: hardcoded mock program emisije su uklonjene. Sve dolazi iz Strapi
 * `programs` kolekcije. Ako Strapi nema podataka, NewsScreen pokazuje empty state.
 */
export const PROGRAM_ITEMS: ProgramItem[] = [];

export const ITEMS_PER_PAGE = 6;
